import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CorporationService } from 'src/app/services/corporation.service';
import { GlobalService } from 'src/app/services/global.service';


@Component({
  selector: 'app-manager-emails',
  templateUrl: './manager-emails.component.html',
  styleUrls: ['./manager-emails.component.css']
})
export class ManagerEmailsComponent {
  emailForm: FormGroup;
  emails: string[] = [];
  isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ManagerEmailsComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private corporationService: CorporationService,
    private globalService: GlobalService
  ) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    if (data.corporationId) {
      this.corporateEmails();
    }
  }

  corporateEmails(): void {
    this.corporationService.getManagerEmails(this.data.corporationId).subscribe((result: any) => {
      this.emails = result.data;
      this.isLoading = false;
    });
  }

  addEmail() {
    this.isLoading = true;
    if (this.emailForm.valid) {
      this.corporationService.saveManagerEmail(this.data.corporationId, this.emailForm.value.email).subscribe((result: any) => {
        this.corporateEmails();
        this.emailForm.reset();
      }, this.globalService.handleError);
    }
  }

  removeEmail(id: number) {
    this.corporationService.deleteManagerEmail(id).subscribe((result: any) => {
      this.corporateEmails();
    }, this.globalService.handleError);
  }

  closeDialog() {
    this.dialogRef.close(this.emails);
  }
}
